/**
 * Auto-découvert par `apps/web/src/routes/modules.ts` via :
 *   import.meta.glob('../../../modules/*\/web/route.tsx', { eager: true })
 */
import { lazy, Suspense, type ReactNode } from 'react';

const VeriteFacturesPage = lazy(() => import('./pages/VeriteFactures'));

function LoadingFallback(): ReactNode {
  return (
    <div className="p-6 text-sm text-slate-500" role="status" aria-live="polite">
      Chargement du module Vérité des factures…
    </div>
  );
}

const route = {
  path: 'verite-factures',
  label: 'Vérité des factures',
  icon: 'receipt-text',
  element: (
    <Suspense fallback={<LoadingFallback />}>
      <VeriteFacturesPage />
    </Suspense>
  ),
};

export default route;
